import React from 'react';
import InactividadAdminWidget from './InactividadAdminWidget';

const GestionInactividadPage = () => {
  return (
    <div className="p-4 sm:p-6 max-w-full" data-testid="gestion-inactividad-page">
      <div className="mb-4">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
          <i className="fas fa-user-slash text-orange-600 mr-2" />
          Gestión de Inactividad
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Usuarios próximos a vencer y desactivados automáticamente por inactividad. Ejecutá el chequeo manual y reactivá cuentas cuando lo necesites.
        </p>
      </div>
      <InactividadAdminWidget />
    </div>
  );
};

export default GestionInactividadPage;
